import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function NuevoParametroFev() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    
    const [resolucion, setResolucion] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [tipo, setTipo] = useState('Factura Electronica');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [facturaInicial, setFacturaInicial] = useState('');
    const [facturaFinal, setFacturaFinal] = useState('');
    const [tipoRegimen, setTipoRegimen] = useState('Sin IVA');
    const [habilitado, setHabilitado] = useState(1);
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const [usersId, setUsersId] = useState('');

    const [errorlist, setErrorlist] = useState([]);
    
    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: '+error);
            });

        // Cargar usuarios del mismo cliente
        axios.get('/usuarios?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: '+error);
            });
    },[]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            uid: userdata.user_id,
            resolucion: resolucion,
            prefijo: prefijo,
            tipo: tipo,
            numero_factura: numeroFactura,
            factura_inicial: facturaInicial,
            factura_final: facturaFinal,
            tipo_regimen: tipoRegimen,
            habilitado: habilitado,
            fecha_vencimiento: fechaVencimiento,
            users_id: usersId
        };

        console.log('Sending data:', conf);
        
        axios.post('/parametro-fev', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El Parámetro "'+resolucion+'" Ha Sido Creado');
                    history.push('/parametros-fev');
                }
            )
            .catch(
                err => {
                    setErrorlist(err.response?.data?.errors || {});
                    setLoading(false);
                }
            )
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-tratamientos">Administrador Contable</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/parametros-fev">Configurar Resolucion</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nueva Resolucion</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nueva Resolucion</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-12">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="parametro-fev-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="resolucion">Resolución Numero</label>
                                                        <input type="text" name="resolucion" className="form-control" id="resolucion" onChange={(e) => setResolucion(e.target.value)} required />
                                                        {errorlist.resolucion && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.resolucion}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="prefijo">Prefijo</label>
                                                        <input type="text" name="prefijo" className="form-control" id="prefijo" onChange={(e) => setPrefijo(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.prefijo}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="tipo">Tipo de Documento</label>
                                                        <select name="tipo" className="form-control" id="tipo" onChange={(e) => setTipo(e.target.value)}>
                                                            <option value="Factura Electronica">Factura Electrónica</option>
                                                            <option value="Nota Credito">Nota Crédito</option>
                                                            <option value="Documento Soporte">Documento Soporte</option>
                                                            <option value="Nota Documento Soporte">Nota Documento Soporte</option>
                                                        </select>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.tipo}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="numeroFactura">Próximo Concecutivo</label>
                                                        <input type="text" name="numeroFactura" className="form-control" id="numeroFactura" onChange={(e) => setNumeroFactura(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.numero_factura}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="facturaInicial">Vigencia Desde</label>
                                                        <input type="text" name="facturaInicial" className="form-control" id="facturaInicial" onChange={(e) => setFacturaInicial(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.factura_inicial}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="facturaFinal">Vigencia Hasta</label>
                                                        <input type="text" name="facturaFinal" className="form-control" id="facturaFinal" onChange={(e) => setFacturaFinal(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.factura_final}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="fechaVencimiento">Fecha Vencimiento</label>
                                                        <input type="date" name="fechaVencimiento" className="form-control" id="fechaVencimiento" onChange={(e) => setFechaVencimiento(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.fecha_vencimiento}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="tipoRegimen">Tipo de Régimen</label>
                                                        <select name="tipoRegimen" className="form-control" id="tipoRegimen" onChange={(e) => setTipoRegimen(e.target.value)}>
                                                            <option value="Sin IVA">Sin IVA</option>
                                                            <option value="Con IVA">Con IVA</option>
                                                        </select>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.tipo_regimen}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="habilitado">Habilitado</label>
                                                        <select name="habilitado" className="form-control" id="habilitado" onChange={(e) => setHabilitado(e.target.value)}>
                                                            <option value={1}>SI</option>
                                                            <option value={0}>NO</option>
                                                        </select>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.habilitado}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="usersId">Usuario</label>
                                                        <select name="usersId" className="form-control" id="usersId" onChange={(e) => setUsersId(e.target.value)}>
                                                            <option value="">Seleccionar Usuario</option>
                                                            {usuarios.map((usuario) => (
                                                                <option key={usuario.id} value={usuario.id}>
                                                                    {usuario.name} {usuario.lastname}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.users_id}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-12">
                                                    <div className="d-flex gap-2">
                                                        <Link to="/parametros-fev" className="btn btn-secondary">
                                                            Cancelar
                                                        </Link>
                                                        <button 
                                                            type="submit" 
                                                            className="btn btn-primary"
                                                            disabled={loading}
                                                        >
                                                            Crear&nbsp;
                                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default NuevoParametroFev;
